const { createApp, ref, reactive, computed, watch, onMounted } = Vue;
class suitcaseCanvas extends HTMLElement {
  // static CANVAS_WIDTH = 774;
  // static CANVAS_HEIGHT = 700;
  static CANVAS_WIDTH = 1000;
  static CANVAS_HEIGHT = 546;
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.image = null;
  }

  connectedCallback() {
    const canvas = document.createElement('canvas');
    canvas.width = suitcaseCanvas.CANVAS_WIDTH;
    canvas.height = suitcaseCanvas.CANVAS_HEIGHT;
    canvas.innerHTML = `
    <style>
      :host canvas{
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      @media (max-width: 1067px){
       :host canvas{
         max-height: 450px;
        }
      }
    </style>
    `;
    this.ctx = canvas.getContext('2d');

    this.shadowRoot.appendChild(canvas);

    this.loadFonts()
      .then(() => {
        this.initialize();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        console.log('Initialize the suitcase personalize app');
      });
  }

  initialize() {
    this.topImage = this.getAttribute('top-image');
    this.backImage = this.getAttribute('back-image');
    this.category = this.getAttribute('category');
    this.text = this.getAttribute('engrave-text') || '';
    this.position = this.getAttribute('engrave-position') || 'center';
    this.fontSize = parseInt(this.getAttribute('engrave-font-size'), 10) || 48;
    this.fontFamily = this.getAttribute('engrave-font-family') || 'Apolline';
    this.textColor = this.getAttribute('engrave-color') || 'rgb(199, 98, 122)';
    this.textShadowColor = this.getAttribute('engrave-shadow-color') || 'rgb(93, 134, 55)';
    this.isLogo = this.getAttribute('is-logo') === 'true';
    this.logo = this.getAttribute('selected-logo');
  }
  loadFonts() {
    const fonts = allPersonalizeFonts(3).map((font) => this.loadFont(font));
    // console.log(fonts);
    return Promise.all(fonts);
  }
  loadFont(font) {
    return new Promise((resolve, reject) => {
      // console.log(font);
      const newFont = new FontFace(font.name, `url(${font.url})`);
      newFont
        .load()
        .then((loadedFont) => {
          document.fonts.add(loadedFont);
          // console.log(loadedFont);
          resolve();
        })
        .catch((error) => {
          console.error(`Failed to loaded font: ${error}`);
          reject(`Chewy font loaded Error`);
        });
    });
  }

  static get observedAttributes() {
    return [
      'image',
      'engrave-text',
      'engrave-position',
      'engrave-font-family',
      'engrave-color',
      'engrave-shadow-color',
      'engrave-font-size',
      'is-logo',
      'selected-logo',
    ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'image' && oldValue !== newValue) {
      this.renderImage(newValue);
    }
    if (name == 'engrave-position' && this.ctx && this.image && oldValue != newValue) {
      this.position = newValue;
      if (newValue == 'center') {
        this.renderImage(this.backImage);
      } else {
        this.renderImage(this.topImage);
      }
    }
    if (name == 'engrave-text' && this.ctx && this.image && oldValue != newValue) {
      this.text = newValue;
      this.drawImage(this.image);
    }
    if (name == 'engrave-color' && this.ctx && this.image && oldValue != newValue) {
      this.textColor = newValue;
      this.drawImage(this.image);
    }
    if (name == 'engrave-shadow-color' && this.ctx && this.image && oldValue != newValue) {
      this.textShadowColor = newValue;
      this.drawImage(this.image);
    }
    if (name == 'engrave-font-family' && this.ctx && this.image && oldValue != newValue) {
      this.fontFamily = newValue;
      this.drawImage(this.image);
    }
    if (name == 'is-logo' && this.ctx && this.image && oldValue != newValue) {
      this.isLogo = newValue === 'true';
      this.drawImage(this.image);
    }
    if (name == 'selected-logo' && this.ctx && this.image && oldValue != newValue) {
      this.logo = newValue;
      this.drawImage(this.image);
    }
  }

  renderImage(url) {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => {
      this.image = image;
      this.drawImage(image);
    };
    image.onerror = () => {
      console.error('Image cannot loaded');
      new Error(`Failed to load image: ${url}`);
    };
    image.src = url;
  }

  drawImage(image) {
    console.log({ image });
    this.ctx.clearRect(0, 0, suitcaseCanvas.CANVAS_WIDTH, suitcaseCanvas.CANVAS_HEIGHT);
    this.ctx.drawImage(image, 0, 0, suitcaseCanvas.CANVAS_WIDTH, suitcaseCanvas.CANVAS_HEIGHT);

    if (this.isLogo) {
      this.drawEngraveLogo();
    } else {
      this.drawEngraveText();
    }
  }

  drawImageWithLogo(image) {
    // console.log({ image });
    this.ctx.clearRect(0, 0, suitcaseCanvas.CANVAS_WIDTH, suitcaseCanvas.CANVAS_HEIGHT);
    this.ctx.drawImage(image, 0, 0, suitcaseCanvas.CANVAS_WIDTH, suitcaseCanvas.CANVAS_HEIGHT);
    if (this.isLogo) {
      this.drawEngraveLogo();
    }
  }

  drawEngraveLogo() {
    let { x, y } = this.getDefaultSuitcase();
    x -= 68;
    y -= 20;

    if (this.category === 'large-check-in-suitcase') {
      ({ x, y } = this.getLargeSuitcase());
      x -= 68;
      if (this.position === 'center') {
        y -= 10;
      }
    } else if (this.category === 'medium-check-in-suitcase') {
      ({ x, y } = this.getMediumSuitcase());
      x -= 68;
      if (this.position === 'center') {
        y -= 10;
      }
    } else if (this.category === 'carry-on-laptop-component') {
      ({ x, y } = this.getCarryOnLaptopSuitcase());
      if (this.position == 'left') {
        x -= 30;
      } else {
        x -= 68;
        y -= 20;
      }
    } else if (this.category === 'underseat-suitcase') {
      ({ x, y } = this.getUnderseatSuitcase());
      if (this.position == 'left') {
        x -= 30;
      } else {
        x -= 68;
      }
    }

    const logoImage = new Image();
    logoImage.src = this.logo;
    logoImage.onload = () => {
      console.log({ height: logoImage.height });
      const logoHeight = logoImage.height;
      const height = logoHeight > 100 ? 100 : logoHeight;
      const dy = logoHeight > 100 ? y - 64 : y - 64 + (100 - logoHeight);

      this.ctx.drawImage(logoImage, x, dy, 100, height);
    };
  }

  getLargeSuitcase() {
    let x = suitcaseCanvas.CANVAS_WIDTH / 2 + 10;
    let y = suitcaseCanvas.CANVAS_HEIGHT * 0.32;
    if (this.position == 'left' || this.position == 'right') {
      y = suitcaseCanvas.CANVAS_HEIGHT - suitcaseCanvas.CANVAS_HEIGHT / 4 + this.fontSize / 3;
    }
    if (this.position == 'left') {
      x = 148;
    }
    if (this.position == 'right') {
      x = suitcaseCanvas.CANVAS_WIDTH - 148;
    }

    return { x, y };
  }

  getMediumSuitcase() {
    let x = suitcaseCanvas.CANVAS_WIDTH / 2 + 10;
    let y = suitcaseCanvas.CANVAS_HEIGHT * 0.38;
    if (this.position == 'left' || this.position == 'right') {
      y = suitcaseCanvas.CANVAS_HEIGHT - suitcaseCanvas.CANVAS_HEIGHT / 4 + this.fontSize / 3;
    }
    if (this.position == 'left') {
      x = 148;
    }
    if (this.position == 'right') {
      x = suitcaseCanvas.CANVAS_WIDTH - 148;
    }

    return { x, y };
  }

  getCarryOnLaptopSuitcase() {
    let x = suitcaseCanvas.CANVAS_WIDTH / 2;
    let y = suitcaseCanvas.CANVAS_HEIGHT * 0.44;
    if (this.position == 'left' || this.position == 'right') {
      y = suitcaseCanvas.CANVAS_HEIGHT - suitcaseCanvas.CANVAS_HEIGHT / 3.25 + this.fontSize / 3;
    }
    if (this.position == 'left') {
      x = 148;
    }
    if (this.position == 'right') {
      x = suitcaseCanvas.CANVAS_WIDTH - 148;
    }
    return { x, y };
  }

  getUnderseatSuitcase() {
    let x = suitcaseCanvas.CANVAS_WIDTH / 2 + 20;
    let y = suitcaseCanvas.CANVAS_HEIGHT * 0.44;
    if (this.position == 'left' || this.position == 'right') {
      y = suitcaseCanvas.CANVAS_HEIGHT - suitcaseCanvas.CANVAS_HEIGHT / 4 + this.fontSize / 3;
    }
    if (this.position == 'left') {
      x = 148;
    }
    if (this.position == 'right') {
      x = suitcaseCanvas.CANVAS_WIDTH - 148;
    }
    return { x, y };
  }

  getDefaultSuitcase() {
    let x = suitcaseCanvas.CANVAS_WIDTH / 2;
    let y = suitcaseCanvas.CANVAS_HEIGHT * 0.44;
    if (this.position == 'left' || this.position == 'right') {
      y = suitcaseCanvas.CANVAS_HEIGHT - suitcaseCanvas.CANVAS_HEIGHT / 4 + this.fontSize / 3;
    }
    if (this.position == 'left') {
      x = 148;
    }
    if (this.position == 'right') {
      x = suitcaseCanvas.CANVAS_WIDTH - 148;
    }
    return { x, y };
  }

  drawEngraveText() {
    let { x, y } = this.getDefaultSuitcase();

    if (this.category === 'large-check-in-suitcase') {
      ({ x, y } = this.getLargeSuitcase());
    } else if (this.category === 'medium-check-in-suitcase') {
      ({ x, y } = this.getMediumSuitcase());
    } else if (this.category === 'carry-on-laptop-component') {
      ({ x, y } = this.getCarryOnLaptopSuitcase());
    } else if (this.category === 'underseat-suitcase') {
      ({ x, y } = this.getUnderseatSuitcase());
    }

    const font = `${this.fontSize}px ${this.fontFamily}`;

    this.ctx.font = font;
    this.ctx.fillStyle = this.textColor;
    this.ctx.textAlign = this.position;

    // Set shadow properties
    this.ctx.shadowColor = rgbToRgba(this.textShadowColor, 0.6); // Shadow color (black with 50% opacity)
    this.ctx.shadowBlur = 2; // Blur level of the shadow
    this.ctx.shadowOffsetX = 4; // Horizontal offset of the shadow
    this.ctx.shadowOffsetY = 4; // Vertical offset of the shadow

    this.ctx.fillText(StringUtils.lettersWithLimit(this.text), x - 14, y); // 14 px less due to look more center

    // Reset shadow properties after drawing
    this.ctx.shadowColor = 'transparent';
    this.ctx.shadowBlur = 0;
    this.ctx.shadowOffsetX = 0;
    this.ctx.shadowOffsetY = 0;

    // const emojiSize = Math.round(this.fontSize * 0.9) + 9;
    // this.renderFilteredText(filterText(this.text), x, y, emojiSize);
  }
  async renderFilteredText(filteredText, startX, y, emojiSize) {
    const spacing = this.fontSize * 0.01; // Adjust this factor to change spacing
    let totalWidth = 0;
    const elements = [];

    // First pass: calculate total width and create all image elements
    for (const item of filteredText) {
      if (item.type === 'text') {
        const textImage = await this.textToImage(item.content, emojiSize, this.fontFamily, this.textColor);
        elements.push({ type: 'text', image: textImage, width: textImage.width });
        totalWidth += textImage.width + spacing;
      } else if (item.type === 'emoji') {
        const img = await this.loadImage(item.url);
        elements.push({ type: 'emoji', image: img, width: emojiSize });
        totalWidth += emojiSize + spacing;
      }
    }

    // Remove last spacing
    totalWidth -= spacing;

    // Calculate starting X position for center alignment
    let x = startX - totalWidth / 2;

    // Second pass: draw all elements
    for (const element of elements) {
      if (element.type === 'text') {
        this.ctx.drawImage(element.image, x, y - this.fontSize);
      } else if (element.type === 'emoji') {
        const yOffset = (this.fontSize - emojiSize - 10) / 2; // Center emoji vertically with text
        this.ctx.drawImage(element.image, x, y - this.fontSize + yOffset, emojiSize, emojiSize);
      }
      x += element.width + spacing;
    }
  }

  textToImage(text, fontSize, fontFamily, color) {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      ctx.font = `${fontSize}px ${fontFamily}`;
      const metrics = ctx.measureText(text);
      const width = metrics.width;
      const height = fontSize * 1.2; // Add some padding

      canvas.width = width;
      canvas.height = height;

      ctx.font = `${fontSize}px ${fontFamily}`;
      ctx.fillStyle = color;
      ctx.textBaseline = 'top';
      ctx.fillText(text, 0, 0);

      const image = new Image();
      image.onload = () => resolve(image);
      image.src = canvas.toDataURL('image/png');
    });
  }

  loadImage(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = url;
    });
  }
}

class CartManager {
  constructor() {
    this.variantSelectElement = document.querySelector('variant-selects');
    this.formElement = document.querySelector('product-form');
    this.inputs = [];
  }

  selectVariant(variantValue = window.personalizeVariant[0].option1) {
    const radioInput = document.querySelector(`input[value="${variantValue}"]`);
    if (radioInput) {
      radioInput.checked = true;
      radioInput.dispatchEvent(new Event('change'));
      this.variantSelectElement.onVariantChange();
    } else {
      console.error('Radio input element not found');
    }
  }

  createInput(options = { value: '', name: '' }) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.value = options.value;
    input.name = `properties[${options.name}]`;
    input.id = `personalize-${options.name}`;

    this.inputs.push(input);
    this.formElement.form.appendChild(input);
  }
  removeInput() {
    this.inputs.forEach((input) => {
      input.remove();
    });
    this.inputs = [];
  }

  addToCart() {
    return new Promise((resolve, reject) => {
      if (!this.formElement) {
        reject('No formElement found');
        return false;
      }
      this.submitForm()
        .then(() => {
          resolve();
        })
        .catch((error) => reject(error));
    });
  }

  submitForm() {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        try {
          this.formElement.onSubmitHandler(new Event('submit', { bubbles: true, cancelable: true }));
          resolve();
        } catch (error) {
          reject(error);
        }
      }, 500);
    });
  }
  destroy() {
    this.selectVariant();
    this.removeInput();
    this.formElement = null;
    this.variantSelectElement = null;
    this.inputs = [];
  }
}
const suitcaseApp = createApp({
  components: {
    CheckmarkIcon,
    DotIcon,
    CircleIcon,
  },
  setup() {
    const show = ref(false);
    const welcomeScreen = ref(false);
    const personalize = ref(true);
    const image = ref(window.personalizeVariant[0].image);
    const images = ref([...window.personalizeVariant[0].images]);
    const personalizeVariants = ref([...window.personalizeVariant]);
    const engrave = ref('');
    const textLimit = ref(3);
    const fonts = reactive([...allPersonalizeFonts(3)]);
    const colors = reactive([...allPersonalizeColors]);
    const positions = reactive([
      {
        id: 0,
        label: 'Top Left',
        value: 'left',
        slug: 'top-left',
        selected: false,
      },
      {
        id: 1,
        label: 'Back Center',
        value: 'center',
        slug: 'back-center',
        selected: true,
      },
      {
        id: 2,
        label: 'Top Right',
        value: 'right',
        slug: 'top-right',
        selected: false,
      },
    ]);
    const logos = reactive([
      {
        id: 0,
        selected: true,
        image: 'https://cdn.shopify.com/s/files/1/1556/0287/files/wicked-logo-1.png?v=1732576207',
      },
      {
        id: 1,
        selected: false,
        image: 'https://cdn.shopify.com/s/files/1/1556/0287/files/wicked.png?v=1732685576',
      },
    ]);
    const logoSelected = ref(logos[0].image);
    const shadowColors = reactive([...allPersonalizeColors]);
    const variant = ref({});
    const disabled = ref(false);

    const isLogo = ref(false);

    // computed method
    const variants = computed(() => personalizeVariants.value.map((v) => v.option1));
    const placeholderText = computed(() => engrave.value);
    const selectedFont = computed(() => fonts.find((font) => font.selected));
    const selectedColor = computed(() => colors.find((color) => color.selected));
    const selectedShadowColor = computed(() => shadowColors.find((color) => color.shadowSelected));
    const selectedPosition = computed(() => positions.find((position) => position.selected));
    const count = computed(() => engrave.value.length);
    const disabledButton = computed(() => {
      if (isLogo.value) {
        return false;
      }
      if (disabled.value || !engrave.value || !variant.value.id) {
        return true;
      }
      return false;
    });

    // method
    const initializeVariant = () => {
      if (personalizeVariants.value.length === 2) {
        const { id, option1 } = personalizeVariants.value[1];
        variant.value = {
          id,
          option1,
        };
      }
    };

    const changeFont = (font) => {
      // console.log(font);
      fonts.forEach((f) => {
        f.selected = f.id === font.id;
      });
    };

    const changeColor = (color) => {
      colors.forEach((c) => {
        c.selected = c.id === color.id;
      });
    };

    const changeShadowColor = (color) => {
      shadowColors.forEach((c) => {
        c.shadowSelected = c.id === color.id;
      });
    };

    const changePosition = (position) => {
      // console.log(position);
      positions.forEach((p) => {
        p.selected = position.id === p.id;
      });
    };

    const changeLogo = (logo) => {
      logos.forEach((l) => {
        l.selected = logo.id === l.id;
      });

      logoSelected.value = logo.image;
    };

    const onKyePress = (event) => {
      const char = String.fromCharCode(event.keyCode || event.which);
      if (!/^[a-zA-Z]+$/.test(char)) {
        event.preventDefault();
        return false;
      }
    };

    const engraveInput = (event) => {
      const input = event.target.value.replace(/[^a-zA-Z]/g, '');
      // console.log({ value: event.target.value, input, engrave: engrave.value });
      engrave.value = input.slice(0, 3);
    };

    const onPaste = (event) => {
      event.preventDefault();
      const pastedText = (event.clipboardData || window.clipboardData).getData('text');
      const processedText = pastedText.replace(/[^a-zA-Z]/g, '').slice(0, 3);
      engrave.value = processedText;
    };

    const canvasMounted = () => {
      if (!customElements.get('suitcase-canvas')) {
        customElements.define('suitcase-canvas', suitcaseCanvas);
      }
    };
    const toggleApp = () => {
      show.value = !show.value;
      welcomeScreen.value = !welcomeScreen.value;
      // isLogo.value = false;
      document.body.classList.toggle('overflow-hidden');
    };
    const reset = () => {
      toggleApp();
      engrave.value = '';
      disabled.value = false;
      changeFont(fonts[0]);
      changeColor(colors[0]);
      changeShadowColor(shadowColors[1]);
      changePosition(positions[1]);
      initializeVariant();
    };
    const closeApp = () => {
      reset();
    };

    const addToCart = () => {
      console.log('adding to the cart');
      disabled.value = true;
      const cartManager = new CartManager();
      cartManager.selectVariant(variant.value.option1);

      const properties = [{ name: 'position', value: selectedPosition.value.label }];
      if (isLogo.value) {
        properties.push({ name: 'logo', value: logoSelected.value });
      } else {
        properties.push(
          { name: 'text', value: engrave.value },
          { name: 'font', value: selectedFont.value.name },
          { name: 'colour', value: selectedColor.value.rgb },
          { name: 'shadowColour', value: rgbToRgba(selectedShadowColor.value.rgb) }
        );
      }
      properties.forEach((property) => {
        cartManager.createInput(property);
      });
      cartManager
        .addToCart()
        .then(() => {
          console.log('added to the cart successfully');
          cartManager.selectVariant(personalizeVariants.value[0].option1);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          cartManager.destroy();
        });
    };

    // watch area
    watch(show, () => {
      if (show.value) {
        canvasMounted();
      }
    });

    /**
     * Toggle App event area
     * control show / hide the personalize
     */
    document.addEventListener('show-app', () => {
      toggleApp();
    });
    /**
     * it will handle product added features
     * event emitter define at product-form.js
     */
    addEventListener('product:added', function (e) {
      if (show.value) {
        reset();
        console.log(e.detail);
      }
    });

    onMounted(() => {
      if (show.value) {
        canvasMounted();
      }
      initializeVariant();
    });

    return {
      show,
      welcomeScreen,
      personalize,
      image,
      images,
      personalizeVariants,
      engrave,
      fonts,
      colors,
      shadowColors,
      positions,
      variant,
      disabledButton,
      variants,
      placeholderText,
      selectedColor,
      selectedShadowColor,
      selectedPosition,
      logoSelected,
      selectedFont,
      variant,
      variants,
      textLimit,
      count,
      isLogo,
      logos,
      changeFont,
      changeColor,
      changeShadowColor,
      changePosition,
      changeLogo,
      engraveInput,
      onKyePress,
      onPaste,
      closeApp,
      addToCart,
    };
  },
});

// Add this configuration to tell Vue about your custom element
suitcaseApp.config.compilerOptions.isCustomElement = (tag) => tag.includes('suitcase-canvas');

suitcaseApp.mount('#suitcase-app');
if (!customElements.get('personalize-button')) {
  class PersonalizeButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('#personalization-button');
      this.handleEvent = this.handleEvent.bind(this);
    }
    connectedCallback() {
      this.button.addEventListener('click', this.handleEvent);
    }
    disconnectedCallback() {
      this.button.removeEventListener('click', this.handleEvent);
    }

    handleEvent() {
      document.dispatchEvent(
        new CustomEvent('show-app', {
          bubbles: true,
        })
      );
    }
  }

  customElements.define('personalize-button', PersonalizeButton);
}
